import passwordResetClient from '@/api/clients/passwordReset';
import * as types from '@/store/mutation-types';

export default {
  sendEmail({ commit }, email) {
    commit(types.SET_STATUS_PENDING, true);
    return passwordResetClient
      .email(email)
      .then(() => {
        commit(types.SET_STATUS_PENDING, false);
        return Promise.resolve();
      })
      .catch((error) => {
        commit(types.SET_STATUS_PENDING, false);
        return Promise.reject(error.response);
      });
  },
  findToken({ commit }, token) {
    commit(types.SET_STATUS_PENDING, true);

    return passwordResetClient
      .find(token)
      .then(({ data }) => {
        const { email } = data;
        commit(types.SET_PASSWORD_RESET_EMAIL, email);
        commit(types.SET_PASSWORD_RESET_TOKEN, token);
        commit(types.SET_STATUS_PENDING, false);
        return Promise.resolve();
      })
      .catch((error) => {
        commit(types.SET_STATUS_PENDING, false);
        return Promise.reject(error.response);
      });
  },
  reset({ state, commit }, credentials) {
    commit(types.SET_STATUS_PENDING, true);

    const data = {
      email: state.email,
      token: state.token,
      password: credentials.password,
      password_confirmation: credentials.passwordConfirmation,
    };

    return passwordResetClient
      .reset(data)
      .then(() => {
        commit(types.SET_STATUS_PENDING, false);
        return Promise.resolve();
      })
      .catch((error) => {
        commit(types.SET_STATUS_PENDING, false);
        return Promise.reject(error.response);
      });
  },
};
